import { render, staticRenderFns } from "./td-Value.vue?vue&type=template&id=ce980872&"
import script from "./td-Value.vue?vue&type=script&lang=js&"
export * from "./td-Value.vue?vue&type=script&lang=js&"
import style0 from "./td-Value.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports